import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { GetQuestionsResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useGetQuestions = (
  id: number | string,
  { enabled = true }: { enabled?: boolean }
) => {
  return useQuery<any, AxiosError<any>, GetQuestionsResponse>(
    ["execution", id, "questions"],
    () =>
      axiosClient
        .get<GetQuestionsResponse>(`/execution/questions/${id}`)
        .then(({ data }) => data),
    {
      staleTime: 0,
      cacheTime: 0,
      enabled,
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
};
